export const menuTypes = {
  MAIN: 'main',
  QUALITY: 'quality',
  PLAYBACKRATE: 'playbackRate'
}
